<template lang="">
	<div
		ref="matSelect"
		class="mdc-select mdc-select--outlined dense"
        :class="{ 'mdc-select--required': required }"
		v-bind="$attrs"
	>
		<div
			class="mdc-select__anchor"
			role="button"
			aria-haspopup="listbox"
			aria-expanded="false"
			aria-labelledby="demo-label demo-selected-text"
			:aria-required="required"
		>
			<span class="mdc-notched-outline">
				<span class="mdc-notched-outline__leading" />
				<span class="mdc-notched-outline__notch">
					<span
						id="outlined-select-label"
						class="mdc-floating-label"
					>{{ label }}</span>
				</span>
				<span class="mdc-notched-outline__trailing" />
			</span>
			<span class="mdc-select__selected-text-container">
				<span
					id="demo-selected-text"
					class="mdc-select__selected-text"
				>
					{{ multipleValue.length ? multipleValue.length + " options sélectionnées" : "Sélectionnez..." }}
				</span>
			</span>
			<span class="mdc-select__dropdown-icon">
				<svg
					class="mdc-select__dropdown-icon-graphic"
					viewBox="7 10 10 5"
					focusable="false"
				>
					<polygon
						class="mdc-select__dropdown-icon-inactive"
						stroke="none"
						fill-rule="evenodd"
						points="7 10 12 15 17 10"
					/>
					<polygon
						class="mdc-select__dropdown-icon-active"
						stroke="none"
						fill-rule="evenodd"
						points="7 15 12 10 17 15"
					/>
				</svg>
			</span>
		</div>
		<MatMenu
			ref="menu"
			type="select"
		>
			<MatOption
				v-for="option in value"
				:key="option"
				:value="option"
			>
				{{ option }}
			</MatOption>	
			<div
				ref="multipleSelection"
				class="mdc-list-item autoselected"
                :data-value="multipleValue"
                style="display: none;"
			>
				<span class="mdc-list-item__text">
					{{ multipleValue.length ? multipleValue.length + " options sélectionnées" : "" }}
				</span>
			</div>
		</MatMenu>
	</div>
    <div class="d-flex flex-wrap align-items-center " 
        v-if="multipleValue.length>1"
        >
        <MatChipset
            v-for="option in multipleValue"
            :key="option"
            :model-value="[{label:option, attributes:{class:'selected-varient'}}]"
            @remove="remove(option)"
		/>
    </div>
</template>
<script>
import MatMenu from "./mat-menu.vue";
import { MDCSelect } from '@material/select';

export default {
    components: { MatMenu },
    props: {
        modelValue: {
            type: [Number, String, Array],
            default: () => "",
        },
        label: {
            type: String,
            default: () => "",
        },
        tabindex: {
            type: String,
            default: () => "-1",
        },
        required: {
            type: Boolean,
            default: () => false,
        },
        multiple: {
            type: Boolean,
            default: () => true,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            multipleText: "",
            multipleValueJoined: "",
            multipleValue: [],
        };
    },
    watch: {
        modelValue() {
            this.init()
        }
    },
    mounted() {
        this.select = new MDCSelect(this.$refs.matSelect);
        this.select.menu.setFixedPosition(true);
        setTimeout(() => {
            this.init();
            this.select.listen('MDCSelect:resize', this.syncMenuWidth);
            if (!this.$ssr) {
                document.querySelector("body").appendChild(this.select.menu.root);
                this.select.menu.root.style.zIndex = 10000
                this.select.menu.root.style.position = "fixed"
                const selectWidth = this.$refs.matSelect.offsetWidth;
                this.$refs.menu.$el.style.width = `${selectWidth - 4}px`;
            }
        })
        this.$nextTick(() => {
            if (this.$ssr) return
            this._onScrollOutside = (e) => {
                // if user scrolls inside the menu itself, do nothing
                if (this.select.menu.root.contains(e.target)) return
                if (this.select?.menu?.open) this.select.menu.open = false
            }

            // capture scrolls from any ancestor/window
            window.addEventListener('scroll', this._onScrollOutside, true)
        })
    },
    beforeUnmount() {
        this.select.unlisten('MDCSelect:resize', this.syncMenuWidth);
        window.removeEventListener('scroll', this._onScrollOutside, true)
    },
    methods: {
        init() {
            this.multipleValue =
                this.modelValue && typeof this.modelValue == "string"
                    ? [this.modelValue]
                    : this.modelValue || [];
            this.selectMultipleValue();
        },
        add(value) {
            this.multipleValue.push(value);
            this.selectMultipleValue(true);
        },
        remove(value) {
            const index = this.multipleValue.indexOf(value);
            if (index >= 0) {
                this.multipleValue.splice(index, 1);
                this.selectMultipleValue(true);
            }
        },
        selectMultipleValue(emit) {
            this.multipleValue = [...new Set(this.multipleValue)];
            setTimeout(() => {
                this.multipleText = this.multipleValue
                    .map((v) => {
                        console.log(v);
                        const escapedValue = v.replace(/'/g, "\\'");
                        const elt = this.$refs.menu.$el.querySelector(`[data-value="${escapedValue}"]`);
                        return elt;
                    })
                    .filter((e) => !!e)
                    .map(
                        (element) => element.querySelector(".mdc-list-item__text").textContent
                    )
                    .join(", ");

                this.multipleValueJoined = this.multipleValue.join(",");
                this.$refs.menu.menu.initialSyncWithDOM();
                this.select.layoutOptions();
                console.log(this.multipleValueJoined);
                this.select.value = this.multipleValueJoined;
                if (emit) {
                    this.$emit("update:modelValue", this.multipleValue);
                }
            }, 100);
        },
    },
};
</script>
<style lang="scss" scoped>
.mdc-select {
    &.dense .mdc-select__anchor {
        height: 40px !important;
    }

    &.dense .mdc-floating-label--float-above {
        transform: translateY(-26.5px) scale(.75);
    }
}
</style>